import React from "react";
import { logoutWithCleanup } from "./env";
import { useAuth } from "./hooks/useAuth";
import { useIdle } from "./hooks/useIdle";
const IdleSessionProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { logout } = useAuth();

  const idleTimeout = 60 * 15;
  const handleIdle = React.useCallback(() => {
    // eslint-disable-next-line no-console
    console.warn("User is idle.");
    logoutWithCleanup(logout);
  }, [logout]);
  useIdle(handleIdle, idleTimeout);
  return <>{children}</>;
};

export default IdleSessionProvider;
